export class ArrangementFields {
  static readonly CountryCode = 'CountryCode';
  static readonly Name = 'Name';
  static readonly Description = 'Description';
  static readonly InceptionDate = 'InceptionDate';
  static readonly FirstTransactionDate = 'FirstTransactionDate';
  static readonly ReportingEntity = 'ReportingEntity';
  static readonly CountryToReport = 'CountryToReport';
  static readonly ArrangementDate = 'ArrangementDate';
  static readonly ReportingDate = 'ReportingDate';
  static readonly DateOfArrangement = 'DateOfArrangement';
  static readonly ReportingDueDate = 'ReportingDueDate';
  static readonly MappedWithTransaction = 'MappedWithTransaction';
  static readonly ReportingFrequency = 'ReportingFrequency';
  static readonly ReportingFrequencyId = 'ReportingFrequencyId';
  static readonly FilingStages = 'FilingStages';
  static readonly Tag = 'Tag';
}

export class CommonFields {
  static readonly CaseGuid = 'CaseGUID';
  static readonly ArrangementGuid = 'ArrangementGUID';
  static readonly CountryName = 'CountryName';
  static readonly FiledPeriodId = 'FiledPeriodId';
  static readonly FiledPeriodTitle = 'FiledPeriodTitle';
  static readonly Tooltip = 'Tooltip';
}

export class FilingStages {
  static readonly MovedToMonthly = 'Moved To Monthly';
  static readonly MovedToQuarterly = 'Moved To Quarterly';
  static readonly MovedToAnnually = 'Moved To Annually';
  static readonly CopiedToQuarterly = 'Copied To Quarterly';
  static readonly CopiedToAnnually = 'Copied To Annually';
  static readonly CopiedToNextQuarter = 'Copied To Next Quarter';
  static readonly CopiedToNextYear = 'Copied To Next Year';
}
